


































































































import mixins from 'vue-typed-mixins';
import RoleUtils, {
  Role,
  Privilege,
  PrivilegeType,
} from '../../utils/RoleUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Role,
    },
  },

  computed: {
    typeOptions(): any {
      return this.privilegeTypes?.map((type) => ({
        text: this.$tc(`model.role.type.${type}`),
        value: type,
      }));
    },
    privilegeOptions(): any {
      return this.privileges?.map((privilege) => ({
        text: this.$tc(`model.role.privileges.${privilege}`),
        value: privilege,
      }));
    },
  },

  data(): {
    privileges?: Privilege[];
    privilegeTypes?: PrivilegeType[];
  } {
    return {
      privileges: undefined,
      privilegeTypes: undefined,
    };
  },

  async mounted() {
    try {
      const resp = await Promise.all([
        RoleUtils.getPrivileges(),
        RoleUtils.getPrivilegeTypes(),
      ]);

      this.privileges = resp[0];
      this.privilegeTypes = resp[1];
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error, this.$refs.observer),
      });
    }
  },
});
